<template>
    <span :class="statusClasses" v-html="status"></span>
</template>

<script>
  export const INPUT_STATE_SAVING = 'saving';
  export const INPUT_STATE_ERROR = 'error';
  export const INPUT_STATE_OK = 'success';

  export default {
    name: 'input-state',
    props: {
      state: String
    },
    computed: {
        status() {
          if (this.state === INPUT_STATE_ERROR)  {
            return '<i class="uk-icon-close"></i>';
          } else if (this.state === INPUT_STATE_SAVING) {
            return '<i class="uk-icon-save"></i>';
          } else if (this.state === INPUT_STATE_OK) {
            return '<i class="uk-icon-check"></i>';
          }

          return '';
        },
      statusClasses() {
        if (this.state === INPUT_STATE_ERROR) {
          return 'inputState--failed';
        } else if (this.state === INPUT_STATE_SAVING) {
          return 'inputState--saving';
        }  else if (this.state === INPUT_STATE_OK) {
          return 'inputState--saved';
        }
      }
    }
  };
</script>

<style scoped>

</style>
